// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RNmOeihFF43ElNUszjgd {
  max-width: 14rem;
  min-height: 36px;
  padding: 0.3rem 0.6rem;
  border: 0.1rem dashed var(--cl-main-intensive-1);
  border-radius: 0.4rem;
  background-color: var(--cl-main-light-2-transparent);
  color: var(--cl-main-dark);
  font: inherit;
  font-size: 0.85rem;
  text-align: left;
  cursor: pointer;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
`, "",{"version":3,"sources":["webpack://./src/merchant/panel/scripts/shared/intInput/IntInput.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,gDAAgD;EAChD,qBAAqB;EACrB,oDAAoD;EACpD,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B","sourcesContent":[".summary {\n  max-width: 14rem;\n  min-height: 36px;\n  padding: 0.3rem 0.6rem;\n  border: 0.1rem dashed var(--cl-main-intensive-1);\n  border-radius: 0.4rem;\n  background-color: var(--cl-main-light-2-transparent);\n  color: var(--cl-main-dark);\n  font: inherit;\n  font-size: 0.85rem;\n  text-align: left;\n  cursor: pointer;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n"],"sourceRoot":""}]);
// Exports
export var summary = `RNmOeihFF43ElNUszjgd`;
export default ___CSS_LOADER_EXPORT___;
